import React, { useEffect, useState } from "react";
import RpmIcon from "../../../../Assets/newicons/Rbm.svg";
import Newpatients from "../../../../Assets/newicons/Totalpatient.svg";
import NewEnroll from "../../../../Assets/newicons/Unroll.svg";
import Compilance from "../../../../Assets/newicons/Compilance.svg";
import ChronicListAgeWise from "./chronicAgeWise";
import ChronicListLocWise from "./chronicLocWise";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import FilterPatients from "./FilterPatients";
import { Flex, Spin } from "antd";
import nodatafound from "../../../../Assets/Images/Svg/nodatafound.svg";
import PatientListByMonth from "./RpmPatientMonth";
import PatientService from "../../../../Services/PatientService";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmDashboardCompliance } from "../../../../Redux/actions/rpmActions";
import { APP_ROUTES } from "../../../../PageRouting/approutes";
import Layouts from "../../../Layouts";

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState(2);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [patientsList, setPatientsList] = useState([]);
  const [totPatientCount, setTotPatientCount] = useState(null);
  const [newEnrollCount, setNewEnrollCount] = useState(null);
  const [rpmPatCount, setRpmPatCount] = useState(null);
  const dispatch = useDispatch();
  const { rpmDashboardCompliance } = useSelector((state) => state.rpm);
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const patPayload = {
      pageNo: currentPage,
      clinicalStatus: selectedFilter,
      status: 1,
      providerCode: loggedUser?.user?.userId,
      hospitalId: loggedUser?.user?.account_Id,
      locationId: loggedUser?.user?.clinic_Id,
    };

    fetchPatients(patPayload);
  }, [selectedFilter]);

  useEffect(() => {
    fetchAllCount();
  }, []);

  useEffect(() => {
    const payload = {
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
      status: 1,
      providerCode: loggedUser?.user?.userId,
      hospitalId: loggedUser?.user?.account_Id,
      locationId: loggedUser?.user?.clinic_Id,
    };

    // if (loggedUser?.user?.rolecode === "ACCT_ADM") {
    //     payload.account_Id = loggedUser.user.account_Id;
    // } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
    //     payload.account_Id = loggedUser.user.account_Id;
    //     payload.clinic_Id = loggedUser.user.clinic_Id;
    // }
    dispatch(fetchRpmDashboardCompliance(payload));
  }, []);
  const fetchPatients = async (payload) => {
    setIsLoading(true);
    try {
      const response = await PatientService.PatientListRPM(payload);
      setPatientsList(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const fetchAllCount = async () => {
    const basePayload = {
      status: 1,
      providerCode: loggedUser?.user?.userId,
      hospitalId: loggedUser?.user?.account_Id,
      locationId: loggedUser?.user?.clinic_Id,
    };
    // if (loggedUser?.user?.rolecode === "ACCT_ADM") {
    //     basePayload.account_Id = loggedUser.user.account_Id;
    // } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
    //     basePayload.account_Id = loggedUser.user.account_Id;
    //     basePayload.clinic_Id = loggedUser.user.clinic_Id;
    // }

    const [fromDate, toDate] = [
      dayjs().startOf("month").format("MM/DD/YYYY"),
      dayjs().endOf("month").format("MM/DD/YYYY"),
    ];

    const totCountPayload = { ...basePayload };
    const rpmPatCountPayload = { ...basePayload, rpmApplicable: "Y" };
    const newEnrollPayload = { ...basePayload, fromDate, toDate };

    try {
      const [totCountRes, rpmCountRes, newEnrollRes] = await Promise.all([
        fetchPatientsCountByFilter(totCountPayload),
        fetchPatientsCountByFilter(rpmPatCountPayload),
        fetchPatientsCountByFilter(newEnrollPayload),
      ]);
      setTotPatientCount(totCountRes.data);
      setRpmPatCount(rpmCountRes.data);
      setNewEnrollCount(newEnrollRes.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchPatientsCountByFilter = async (payload) => {
    try {
      const response = await PatientService.PatientCount(payload);
      return response;
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const goToRpm = () => {
    history.push("/rpm");
  };

  const handlePatFilter = (value) => {
    setSelectedFilter(value);
  };

  const handleViewAllPatients = () => {
    if (selectedFilter === 2) {
      history.push(APP_ROUTES.PATIENTCRITICAL);
    } else if (selectedFilter === 1) {
      history.push(APP_ROUTES.PATIENTABNORMAL);
    } else if (selectedFilter === 0) {
      history.push(APP_ROUTES.PATIENTNORMAL);
    }
  };

  return (
    <Layouts>
      <div className="w-full bg-[#FFFFFF] p-3">
        <div className="xl:flex xl:justify-between lg:flex lg:justify-between md:grid md:grid-cols-1 items-center  w-full">
          <div className="items-center gap-2 flex">
            <img src={RpmIcon} alt="RPM Icon" className="w-9 h-9" />
            <label className="text-base font-inter font-semibold">
              RPM Dashboard
            </label>
          </div>
          {/* <div className="xl:flex gap-8 lg:flex md:flex md:space-y-0 xl:space-y-0 lg:space-y-0 space-y-3 xl:mt-0 lg:mt-0 mt-3">
                    <div className="flex items-center bg-white rounded-3xl cursor-pointer text-[#FF3022] text-sm border border-[#FF3022] pr-3">
                        <div className="bg-[#FF3022] py-1 px-3 mr-2 rounded-full">
                            <img src={priorityIcon} alt="Critical" width="20" />
                        </div>
                        Critical Patients (5)
                    </div>
                    <div className="flex items-center bg-white rounded-3xl cursor-pointer text-[#FFA12C] text-sm border border-[#FFA12C] pr-3">
                        <div className="bg-[#FFA12C] py-1 px-3 mr-2 rounded-full">
                            <img src={priorityIcon1} alt="Abnormal" width="20" />
                        </div>
                        Abnormal Patients (8)
                    </div>
                    <div className="flex items-center bg-white rounded-3xl cursor-pointer text-[#00B24B] text-sm border border-[#00B24B] pr-3">
                        <div className="bg-[#00B24B] py-1 px-3 mr-2 rounded-full">
                            <img src={priorityIcon2} alt="Normal" width="20" />
                        </div>
                        Normal Patients (12)
                    </div>
                </div> */}
          <div></div>
        </div>
        <hr className="mt-4" />
        <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-3">
          <div className="xl:flex lg:flex xl:mt-8 lg:mt-6 grid grid-cols-2 xl:gap-4 lg:gap-4 gap-6">
            <div className="bg-gradient-to-r from-[#134E5E] to-[#71B280] rounded-lg text-white xl:p-4 lg:p-4 md:p-2 p-1 flex items-center justify-between shadow xl:w-[28%] lg:w-[28%] w-full">
              <div className="xl:flex lg:flex md:flex items-center xl:gap-3 lg:gap-3 md:gap-3 space-y-1">
                <div className="border rounded-md xl:w-10 xl:h-10 lg:w-10 lg:h-10 md:w-10 md:h-10 h-7 w-8 bg-white flex items-center justify-center">
                  <img
                    src={Newpatients}
                    alt=""
                    className="xl:w-8 lg:h-8 lg:w-8 xl:h-8 md:w-8 md:h-8 w-5 h-5"
                  />
                </div>
                <label className="xl:text-base lg:text-base md:text-base text-xs">
                  Total Patients
                </label>
              </div>
              <label className="xl:text-xl lg:text-xl text-base font-bold">
                {totPatientCount?.TOTAL_COUNT_STATUS}
              </label>
            </div>
            <div className="bg-gradient-to-r from-[#2C3E50] to-[#4CA1AF] rounded-lg text-white p-4 flex items-center justify-between shadow xl:w-[28%] lg:w-[28%] w-full">
              <div className="xl:flex lg:flex md:flex items-center xl:gap-3 lg:gap-3 md:gap-3 space-y-1">
                <div className="border rounded-md xl:w-10 xl:h-10 lg:w-10 lg:h-10 md:w-10 md:h-10 h-7 w-8 bg-white flex items-center justify-center">
                  <img
                    src={NewEnroll}
                    alt=""
                    className="xl:w-8 lg:h-8 lg:w-8 xl:h-8 md:w-8 md:h-8 w-5 h-5"
                  />
                </div>
                <label className="xl:text-base lg:text-base md:text-base text-xs">
                  New Enrolments
                </label>
              </div>
              <label className="xl:text-xl lg:text-xl text-base font-bold">
                {newEnrollCount?.TOTAL_COUNT_STATUS}
              </label>
            </div>
            <div className="bg-gradient-to-r from-[#404A60] to-[#4F8AEB] rounded-lg text-white p-4 label-4 flex items-center justify-between shadow xl:w-[28%] lg:w-[28%] w-full">
              <div className="xl:flex lg:flex md:flex items-center xl:gap-3 lg:gap-3 md:gap-3">
                <div className="border rounded-md xl:w-10 xl:h-10 lg:w-10 lg:h-10 md:w-10 md:h-10 h-7 w-8 bg-white flex items-center justify-center">
                  <img
                    src={Compilance}
                    alt=""
                    className="xl:w-8 lg:h-8 lg:w-8 xl:h-8 md:w-8 md:h-8 w-5 h-5"
                  />
                </div>
                <label className="xl:text-base lg:text-base md:text-base text-xs">
                  Compliance
                </label>
              </div>
              <label className="xl:text-xl lg:text-xl text-base font-bold">
                {rpmDashboardCompliance
                  ? rpmDashboardCompliance[0]?.compliancePercentage
                  : "-"}
              </label>
            </div>
            <div className="relative h-20 border border-[#C0E0E0] bg-[#F0FEFE] rounded-xl flex items-center justify-center xl:w-[16%] lg:w-[16%] w-full">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <div className="bg-gradient-to-r from-[#65D2D6] to-[#2C7AE7] text-white text-sm font-semibold px-4 py-1 rounded-md shadow ">
                  Program
                </div>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-[#089CA6] xl:text-xl lg:text-xl text-base font-semibold">
                  RPM
                </span>
                <span className="xl:text-xl lg:text-xl text-base font-bold  text-gray-800">
                  - {rpmPatCount?.TOTAL_COUNT_STATUS}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-5 p-3 border rounded-md">
            <div className="xl:flex xl:items-center xl:justify-between lg:flex lg:items-center lg:justify-between md:flex md:items-center md:justify-between">
              <div className="xl:flex lg:flex md:flex grid grid-cols-2 gap-3">
                <label className="px-4 xl:text-base lg:text-base md:text-base text-sm font-inter font-medium">
                  Clinical Status
                </label>
                <button
                  className={`xl:px-4 xl:py-1 lg:px-4 lg:py-1 md:px-4 md:py-1 py-1 text-sm border rounded-full font-inter font-medium ${
                    selectedFilter === 2 ? "newbutton" : "Button"
                  }`}
                  onClick={() => handlePatFilter(2)}
                >
                  Critical Patients
                </button>
                <button
                  className={`xl:px-4 xl:py-1 lg:px-4 lg:py-1 md:px-4 md:py-1 py-1 px-0.5 text-sm border rounded-full font-inter font-medium ${
                    selectedFilter === 1 ? "newbutton" : "Button"
                  }`}
                  onClick={() => handlePatFilter(1)}
                >
                  Abnormal Patients
                </button>
                <button
                  className={`xl:px-4 xl:py-1 lg:px-4 lg:py-1 md:px-4 md:py-1 py-1 text-sm border rounded-full font-inter font-medium ${
                    selectedFilter === 0 ? "newbutton" : "Button"
                  }`}
                  onClick={() => handlePatFilter(0)}
                >
                  Normal Patients
                </button>
              </div>
              {/* <button className="text-sm text-sky-500 cursor-pointer font-inter font-semibold xl:mt-0 lg:mt-0 md:mt-0 mt-3 flex justify-end" onClick={handleViewAllPatients}>
                                View all
                            </button> */}
            </div>
            <div className="overflow-auto rounded-lg border bg-white mt-5 h-[350px] overflow-y-scroll scrollwidth">
              {isLoading === true && patientsList?.length === 0 ? (
                <div className="flex items-center justify-center mt-[10%]">
                  <Flex align="center" gap="middle">
                    <Spin size="large" tip="Loading" />
                  </Flex>
                </div>
              ) : isLoading === false && patientsList?.length === 0 ? (
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={nodatafound}
                    alt="nodatafound"
                    className="h-56 w-56"
                  />
                  <p className="font-medium text-lg">No data found!!</p>
                </div>
              ) : (
                <div>
                  <FilterPatients
                    data={patientsList}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="xl:flex xl:justify-between lg:flex lg:justify-between grid grid-cols-1 w-full gap-5 mt-5">
            <ChronicListLocWise />
            <ChronicListAgeWise />
          </div>
          <div>
            <PatientListByMonth />
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default Index;
